<template>
  <div 
    class="fill-height">
    <v-layout wrap>
      <v-flex>
        <v-snackbar
          v-model="dialog.snackbar"
          top
          right
          color="green">
          <span 
            class="body-1 font-weight-light white--text"
            v-html="message.success">
          </span>

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              color="white"
              class="body-1 font-weight-bold text-capitalize"
              v-bind="attrs"
              @click="dialog.snackbar = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>

        <v-dialog v-model="dialog.freeze"
          @keydown.esc="dialog.freeze = false"
          :fullscreen="dialog.fullscreen"
          width="400"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pt-3 pb-0 text-right popup-header">
              Freeze Kolom

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mt-3 mb-2"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-text 
              class="py-0">
              <v-form>
                <v-row>
                  <v-col>
                    <div>
                      <div 
                        class="mb-2">
                        Silahkan pilih kolom yang akan di <b class="font-italic">"Freeze"</b>
                      </div>

                      <v-list-item-group
                        multiple>
                        <v-list flat>
                          <v-list-item 
                            v-for="(item, index) in configHeaders" 
                            :key="index"
                            class="px-0"
                            @click="item.freeze = !item.freeze ? true : false">
                            <v-list-item-action 
                              class="mr-4">
                              <v-checkbox
                                :color="set_color"
                                :input-value="item.freeze">
                              </v-checkbox>
                            </v-list-item-action>

                            <v-list-item-content>
                              <div
                                :class="item.freeze ? 'font-weight-bold' : ''"
                                :style="item.freeze ? `color: ${set_color};` : ''">
                                {{ item.text }}
                              </div>
                            </v-list-item-content>
                          </v-list-item>  
                        </v-list>
                      </v-list-item-group>
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>

            <v-divider 
              class="mb-3 mt-0"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-actions
              class="mb-2">
              <v-spacer/>

              <v-btn
                elevation="0"
                :color="set_color"
                style="border-radius: 10px;"
                class="body-2 font-weight-bold text-capitalize white--text"
                @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();">
                <v-icon small class="mr-1">mdi-check-bold</v-icon>
                Freeze
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.hide"
          @keydown.esc="dialog.hide = false"
          :fullscreen="dialog.fullscreen"
          width="400"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pt-3 pb-0 text-right popup-header">
              Hide Kolom

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.hide = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mt-3 mb-2"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-text 
              class="py-0">
              <v-form>
                <v-row>
                  <v-col>
                    <div>
                      <div class="mb-2">
                        Silahkan pilih kolom yang akan di <b class="font-italic">"Hide"</b>
                      </div>

                      <v-list-item-group
                        multiple>
                        <v-list flat>
                          <v-list-item 
                            v-for="(item, index) in headers" 
                            :key="index"
                            class="px-0"
                            @click="item.hide = !item.hide ? true : false">
                            <v-list-item-action 
                              class="mr-4">
                              <v-checkbox
                                :color="set_color"
                                :input-value="item.hide">
                              </v-checkbox>
                            </v-list-item-action>

                            <v-list-item-content>
                              <div
                                :class="item.hide ? 'font-weight-bold' : ''"
                                :style="item.hide ? `color: ${set_color};` : ''">
                                {{ item.text }}
                              </div>
                            </v-list-item-content>
                          </v-list-item>  
                        </v-list>
                      </v-list-item-group>
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>

            <v-divider 
              class="mb-3 mt-0"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-actions
              class="mb-2">
              <v-spacer/>

              <v-btn
                elevation="0"
                :color="set_color"
                style="border-radius: 10px;"
                class="body-2 font-weight-bold text-capitalize white--text"
                @click="dialog.hide = false; dialog.fullscreen = false; addHides();">
                <v-icon small class="mr-1">mdi-check-bold</v-icon>
                Hide
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <section>
          <v-row
            class="pa-4 pb-2 pr-1">
            <v-col
              cols="12">
              <v-card
                to="/program"
                flat
                color="transparent">
                <div
                  class="d-flex align-center">
                  <div
                    class="d-flex align-center">
                    <v-avatar
                      tile
                      size="28"
                      style="opacity: 30%;">
                      <v-img
                        contain
                        alt="kominfoklaten"  
                        :src="require('@/assets/icon/back_arrow.png')">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              size="20"
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-avatar>

                    <span
                      class="title black--text ml-3"
                      style="font-weight: 600;">
                      <span v-if="detail.type === 'Program'">
                        Program
                      </span>

                      <span v-if="detail.type === 'Kegiatan'"
                        class="d-flex align-center">
                        <span>
                          Program
                        </span>

                        <v-icon size="20" class="mx-1" style="opacity: 70%;">mdi-arrow-right</v-icon>

                        <span>
                          Kegiatan
                        </span>
                      </span>

                      <span v-if="detail.type === 'Sub Kegiatan'"
                        class="d-flex align-center">
                        <span>
                          Program
                        </span>

                        <v-icon size="20" class="mx-1" style="opacity: 70%;">mdi-arrow-right</v-icon>

                        <span>
                          Kegiatan
                        </span>

                        <v-icon size="20" class="mx-1" style="opacity: 70%;">mdi-arrow-right</v-icon>

                        <span>
                          Sub Kegiatan
                        </span>
                      </span>
                    </span>
                  </div>

                  <v-spacer />

                  <div v-if="user.role === 'admin'">
                    <v-btn
                      :to="`/program/edit/${detail.id}?from=detail&unit_id=${$route.query.unit_id}&year=${$route.query.year}`"
                      color="#4B4B4B"
                      elevation="0"
                      class="body-2 white--text text-capitalize d-flex align-center"
                      style="border-radius: 10px; font-weight: 600; background: linear-gradient(180deg, rgba(31, 150, 243, 1), rgba(25, 110, 176, 1));">
                      <v-icon size="20">mdi-progress-pencil</v-icon>
                      
                      <span
                        class="ml-2">
                        Ubah
                      </span>
                    </v-btn>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              class="py-0">
              <v-card 
                flat
                class="mb-5"
                style="border-radius: 10px; border: 1px solid #E7E7E7; overflow-y: auto;">
                <v-card-text>
                  <div
                    class="body-1 font-weight-bold black--text mb-4">
                    #General
                  </div>

                  <v-row>
                    <v-col
                      cols="3"
                      class="py-0">
                      <div
                        class="black--text d-flex align-center mb-2">
                        Program

                        <v-spacer />

                        :
                      </div>
                    </v-col>

                    <v-col
                      cols="9"
                      class="py-0 pl-0">
                      <div
                        class="black--text mb-2">
                        {{ nama_program }}
                      </div>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col
                      cols="3"
                      class="py-0">
                      <div
                        class="black--text d-flex align-center mb-2">
                        Kegiatan

                        <v-spacer />

                        :
                      </div>
                    </v-col>

                    <v-col
                      cols="9"
                      class="py-0 pl-0">
                      <div
                        class="black--text mb-2">
                        {{ nama_kegiatan }}
                      </div>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col
                      cols="3"
                      class="py-0">
                      <div
                        class="black--text d-flex align-center mb-2">
                        {{ detail.type }}

                        <v-spacer />

                        :
                      </div>
                    </v-col>

                    <v-col
                      cols="9"
                      class="py-0 pl-0">
                      <div
                        class="black--text mb-2">
                        {{ detail.code }} {{ detail.code !== '' ? '-' : '' }} {{ detail.title }}
                      </div>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col
                      cols="3"
                      class="py-0">
                      <div
                        class="black--text d-flex align-center mb-2">
                        Anggaran (DPA)

                        <v-spacer />

                        :
                      </div>
                    </v-col>

                    <v-col
                      cols="9"
                      class="py-0 pl-0">
                      <div
                        class="black--text font-weight-bold mb-2">
                        {{ parseInt(detail.anggaran) | price }}
                      </div>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col
                      cols="3"
                      class="py-0">
                      <div
                        class="black--text d-flex align-center mb-2">
                        Anggaran Terakhir (PERUBAHAN)

                        <v-spacer />

                        :
                      </div>
                    </v-col>

                    <v-col
                      cols="9"
                      class="py-0 pl-0">
                      <div
                        class="black--text font-weight-bold mb-2">
                        {{ parseInt(detail.anggaran_perubahan) | price }}
                      </div>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col
                      cols="3"
                      class="py-0">
                      <div
                        class="black--text d-flex align-center mb-2">
                        Tahun Anggaran

                        <v-spacer />

                        :
                      </div>
                    </v-col>

                    <v-col
                      cols="9"
                      class="py-0 pl-0">
                      <div
                        class="black--text mb-2">
                        {{ detail.tahun_anggaran }}
                      </div>
                    </v-col>
                  </v-row>
                  
                  <v-row>
                    <v-col
                      cols="3"
                      class="py-0">
                      <div
                        class="black--text d-flex align-center mb-2">
                        PPKOM

                        <v-spacer />

                        :
                      </div>
                    </v-col>

                    <v-col
                      cols="9"
                      class="py-0 pl-0">
                      <div
                        class="black--text mb-2">
                        {{ detail.ppkom_name !== '' ? detail.ppkom_name : '-' }}
                      </div>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col
                      cols="3"
                      class="py-0">
                      <div
                        class="black--text d-flex align-center">
                        PPTK

                        <v-spacer />

                        :
                      </div>
                    </v-col>

                    <v-col
                      cols="9"
                      class="py-0 pl-0">
                      <div
                        class="black--text">
                        {{ detail.pptk_name !== '' ? detail.pptk_name : '-' }}
                      </div>
                    </v-col>
                  </v-row>


                  <v-row>
                    <v-col
                      cols="3"
                      class="">
                      <div
                        class="black--text d-flex align-center">
                        Indikator

                        <v-spacer />

                        :
                      </div>
                    </v-col>

                    <v-col
                      cols="9"
                      class="pl-0">
                      <div
                        class="black--text">
                        {{ detail.indikator !== '' ? detail.indikator : '-' }}
                      </div>
                    </v-col>

                  </v-row>

                  <v-row>
                    <v-col
                      cols="3"
                      class="py-0">
                      <div
                        class="black--text d-flex align-center">
                        Target Kinerja

                        <v-spacer />

                        :
                      </div>
                    </v-col>

                    <v-col
                      cols="9"
                      class="py-0 pl-0">
                      <div
                        class="black--text">
                        {{ detail.output !== '' ? detail.output : '-' }}
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <v-row v-if="detail.type === 'Sub Kegiatan'"
                justify="end">
                <v-col
                  cols="2">
                  <v-btn
                    :to="`/program/edit/realisasi/${detail.id}?from=detail&unit_id=${detail.unit_id}&year=${detail.tahun_anggaran}`"
                    color="#4B4B4B"
                    elevation="0"
                    class="body-2 white--text text-capitalize d-flex align-center"
                    style="border-radius: 10px; font-weight: 600; background: linear-gradient(180deg, rgba(31, 150, 243, 1), rgba(25, 110, 176, 1));">
                    <v-icon size="20">mdi-progress-pencil</v-icon>
                    
                    <span
                      class="ml-2">
                      Ubah Realisasi
                    </span>
                  </v-btn>
                </v-col>
              </v-row>

              <v-card
                flat
                class="mb-4"
                style="border-radius: 10px; border: 1px solid #E7E7E7; overflow-y: auto;">
                <v-card-text
                  class="grafik_loader">
                  <div
                    class="body-1 font-weight-bold black--text mb-4">
                    #Grafik Fisik
                  </div>

                  <v-skeleton-loader
                    :loading="process.load"
                    type="image">
                    <div>
                      <div v-if="!process.load && Object.keys(this.bar_target).length > 0">
                        <apexchart 
                          height="400" 
                          :options="bar_target.chartOptions" 
                          :series="bar_target.series">
                        </apexchart>
                      </div>
                    </div>
                  </v-skeleton-loader>
                </v-card-text>
              </v-card>

              <v-card
                flat
                :class="detail.type !== 'Sub Kegiatan' ? 'mt-5' : ''"
                style="border-radius: 10px; border: 1px solid #E7E7E7; overflow-y: auto;">
                <v-card-text
                  class="grafik_loader">
                  <div
                    class="body-1 font-weight-bold black--text mb-4">
                    #Grafik Keuangan
                  </div>

                  <v-skeleton-loader
                    :loading="process.load"
                    type="image">
                    <div>
                      <div v-if="!process.load && Object.keys(this.bar_realisasi).length > 0">
                        <apexchart 
                          height="400" 
                          :options="bar_realisasi.chartOptions" 
                          :series="bar_realisasi.series">
                        </apexchart>
                      </div>
                    </div>
                  </v-skeleton-loader>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        checkbox: false,

        expanded_program: [],
        expanded_kegiatan: [],

        dialog: {
          fullscreen: false,
          snackbar: false,
          freeze: false,
          hide: false
        },

        nama_kegiatan: '',
        nama_program: '',
        
        search: '',

        selected: {
          row: [],

          freeze: []
        },

        detail: {},
        target_dan_realisasi: [],

        target_keuangan: [],
        target_fisik: [],

        realisasi_keuangan: [],
        realisasi_fisik: [],

        options: {},
        headers: [],
        list: [],
        pagination: {},

        lastIndex: 0,
        limit: 20,

        bar_target: {},
        bar_realisasi: {},

        process: {
          load: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination.vue')
    },
    watch: {
      
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      user () {
        return this.$store.state.user
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      },

      configHeaders () {
        return this.headers.filter(header => !header.hide)  
      }
    },
    mounted () {
      this.fetchDetail()
    },
    methods: {
      async fetchDetail () {
        this.process.load = true

        let params = {
          id: this.$route.params.id
        }

        await get('admin/task/detail', { params })
        .then(response => {
          let res = response.data

          this.process.load = false
            
          if (res.status === 200) {
            this.detail = res.results.data

            let tdr = [],
                target_uang = [],
                target_fisik = [],
                realisasi_uang = [],
                realisasi_fisik = []

            target_uang = [
              this.detail.target_keu_1,
              this.detail.target_keu_2,
              this.detail.target_keu_3,
              this.detail.target_keu_4,
              this.detail.target_keu_5,
              this.detail.target_keu_6,
              this.detail.target_keu_7,
              this.detail.target_keu_8,
              this.detail.target_keu_9,
              this.detail.target_keu_10,
              this.detail.target_keu_11,
              this.detail.target_keu_12
            ]

            target_fisik = [
              this.detail.target_fisik_1,
              this.detail.target_fisik_2,
              this.detail.target_fisik_3,
              this.detail.target_fisik_4,
              this.detail.target_fisik_5,
              this.detail.target_fisik_6,
              this.detail.target_fisik_7,
              this.detail.target_fisik_8,
              this.detail.target_fisik_9,
              this.detail.target_fisik_10,
              this.detail.target_fisik_11,
              this.detail.target_fisik_12
            ]

            realisasi_uang = [
              this.detail.realisasi_keu_1,
              this.detail.realisasi_keu_2,
              this.detail.realisasi_keu_3,
              this.detail.realisasi_keu_4,
              this.detail.realisasi_keu_5,
              this.detail.realisasi_keu_6,
              this.detail.realisasi_keu_7,
              this.detail.realisasi_keu_8,
              this.detail.realisasi_keu_9,
              this.detail.realisasi_keu_10,
              this.detail.realisasi_keu_11,
              this.detail.realisasi_keu_12
            ]

            realisasi_fisik = [
              this.detail.realisasi_fisik_1,
              this.detail.realisasi_fisik_2,
              this.detail.realisasi_fisik_3,
              this.detail.realisasi_fisik_4,
              this.detail.realisasi_fisik_5,
              this.detail.realisasi_fisik_6,
              this.detail.realisasi_fisik_7,
              this.detail.realisasi_fisik_8,
              this.detail.realisasi_fisik_9,
              this.detail.realisasi_fisik_10,
              this.detail.realisasi_fisik_11,
              this.detail.realisasi_fisik_12
            ]

            this.bar_target = {
              series: [
                
                {
                  name: 'Target Fisik',
                  data: target_fisik
                },
                {
                  name: 'Realisasi Fisik',
                  data: realisasi_fisik
                },
              ],
              chartOptions: {
                chart: {
                  animations: {
                    enabled: true,
                    easing: 'linear',
                    dynamicAnimation: {
                      speed: 1000
                    }
                  },
                  toolbar: {
                    show: true
                  },
                  zoom: {
                    enabled: true
                  }
                },
                stroke: {
                  width: 3,
                  curve: 'smooth'
                },
                dataLabels: {
                  enabled: true
                },
                colors: ['#FF9800', '#00BCD4', '#9C27B0', '#F44336', '#2196F3', '#4CAF50'],
                yaxis: {
                  labels: {
                    formatter: function (value) {
                      return Math.round(value)
                    }
                  }
                },
                xaxis: {
                  categories: [
                    "Jan",
                    "Feb",
                    "Mar",
                    "Apr",
                    "Mei",
                    "Jun",
                    "Jul",
                    "Agu",
                    "Sep",
                    "Okt",
                    "Nov",
                    "Des"
                  ]
                }
              }
            }

            this.bar_realisasi = {
              series: [
                {
                  name: 'Target Keuangan',
                  data: target_uang
                },
                {
                  name: 'Realisasi Keuangan',
                  data: realisasi_uang
                }
              ],
              chartOptions: {
                chart: {
                  animations: {
                    enabled: true,
                    easing: 'linear',
                    dynamicAnimation: {
                      speed: 1000
                    }
                  },
                  toolbar: {
                    show: true
                  },
                  zoom: {
                    enabled: true
                  }
                },
                stroke: {
                  width: 3,
                  curve: 'smooth'
                },
                dataLabels: {
                  enabled: true
                },
                colors: ['#FF9800', '#00BCD4', '#9C27B0', '#F44336', '#2196F3', '#4CAF50'],
                yaxis: {
                  labels: {
                    formatter: function (value) {
                      return Math.round(value)
                    }
                  }
                },
                xaxis: {
                  categories: [
                    "Jan",
                    "Feb",
                    "Mar",
                    "Apr",
                    "Mei",
                    "Jun",
                    "Jul",
                    "Agu",
                    "Sep",
                    "Okt",
                    "Nov",
                    "Des"
                  ]
                }
              }
            }


            this.fetchDetailKegiatan(this.detail.par_id)
          }
        })
      },

      async fetchDetailKegiatan (id) {

        let params = {
          id: id
        }

        await get('admin/task/detail', { params })
        .then(response => {
          let res = response.data
          if (res.status === 200) {
            this.nama_kegiatan = res.results.data.title
            this.fetchDetailProgram(res.results.data.par_id)
          }
        })
      },

      async fetchDetailProgram (id) {

        let params = {
          id: id
        }

        await get('admin/task/detail', { params })
        .then(response => {
          let res = response.data
          if (res.status === 200) {
            this.nama_program = res.results.data.title
          }
        })
      },

      rowFormat (format, value) {
        let data = value

        if (format === 'number') {
          if (isNaN(value)) return 'Not a Number'
          let price = ''

          const reverseNumber = value
            .toString()
            .split('')
            .reverse()
            .join('')
          const arrReverseNumber = [...Array(reverseNumber.length).keys()]

          arrReverseNumber.map(index => {
            if (index % 3 === 0) price += reverseNumber.substr(index, 3) + '.'
          })

          return `Rp ${
            price.split('', price.length - 1)
            .reverse()
            .join('')
          }`
        } else if (format === 'array') {
          let arr = []

          for (let i = 0; i < value.length; i++) {
            arr.push(value[i].label)
          }

          data = arr.join(', ')
        } else if (format === 'date') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY') : '-'
        } else if (format === 'time') {
          data = value.length > 0 ? moment(value).format('HH:mm') : '-'
        } else if (format === 'datetime') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY HH:mm') : '-'
        } else if (format === 'object') {
          data = value.createdby.name
        } else if (format === 'regex') {
          let regex = /(<([^>]+)>)/ig

          data = value.replace(regex, '')
        } else if (format === 'underscore') {
          let regex = /_/g

          data = value.replace(regex, ' ')
        } else if (format === 'on_off') {
          data = value ? 'Online' : 'Offline'
        } else if (format === 'g_m') {
          data = value ? 'Mandiri' : 'Group'
        } else if (format === 'v_a') {
          data = value ? 'Sudah Verifikasi' : 'Belum Verifikasi'
        } else if (format === 'y_n') {
          data = parseInt(value) ? 'Ya' : 'Tidak'
        } else if (format === 'percent') {
          data = Number(value) + ' %'
        } else if (format === 'action') {
          data = value
        } else if (format === 'bool') {
          data = value
        } else if (format === 'status') {
          data = value
        } else if (format === 'link') {
          data = value
        }  else {
          data = value ? 'Aktif' : 'Tidak Aktif'
        }

        return data
      },
      rowClick (item, row) {
        row.select(!row.isSelected ? true : false)
      },
      handleToggle (event) {
        if (!event.value) this.selected.row = []
      },

      addFreezes () {
        this.removeFreezes()

        this.selected.freeze = []

        for (let i = 0; i < this.configHeaders.length; i++) {
          if (this.configHeaders[i].freeze) {
            // ADD TO SELECTOR
            this.selected.freeze.push({
              child: i + (this.checkbox ? 2 : 1),
              width: this.configHeaders[i].width.split('px')[0]
            })

            // LOOP STYLESHEET
            for (let f = 0; f < this.selected.freeze.length; f++) {
              let style = document.createElement('style'),
                  width = 0

              if (this.checkbox) {
                width = f < 1 ? '65' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) + 65 : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width) + 65
              } else {
                width = f < 1 ? '0' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width)
              }

              // ADD STYLESHET TO FREEZE
              style.innerHTML = `
                .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 5;
                  background: #FFFFFF;
                }

                .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 1;
                }
              `

              // ADD TO APPENDCHILD
              document.head.appendChild(style)
            }
          }
        }
      },
      removeFreezes () {
        // LOOP STYLESHEET
        for (let f = 0; f < this.selected.freeze.length; f++) {
          let style = document.createElement('style')
          
          // RESET STYLESHEET TO AUTO
          style.innerHTML = `
            .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
              background: #FFFFFF;
            }

            .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
            }
          `

          // ADD TO APPENDCHILD
          document.head.appendChild(style)
        }
      },
      addHides () {
        if (this.headers.length < 6) this.getTableToResize()
      },
      getTableToResize () {
        let tables = document.getElementsByTagName('table')

        for (let i = 0; i < tables.length; i++) {
          this.resizableGrid(tables[i])
        }
      },
      resizableGrid (table) {
        let row = table.getElementsByTagName('tr')[0],
            cols = row ? row.children : undefined
        
        if (!cols) return
        
        table.style.overflow = 'hidden'
        
        let tableHeight = table.offsetHeight
        
        for (let i = 0; i < cols.length; i++) {
          let div = createDiv(tableHeight)
          cols[i].appendChild(div)
          cols[i].style.position = 'relative'

          setListeners(div)
        }

        function setListeners (div) {
          let pageX, curCol, nxtCol, curColWidth, nxtColWidth

          div.addEventListener('mousedown', e => {
            curCol = e.target.parentElement
            nxtCol = curCol.nextElementSibling
            pageX = e.pageX
            
            let padding = paddingDiff(curCol)
            
            curColWidth = curCol.offsetWidth - padding

            if (nxtCol) nxtColWidth = nxtCol.offsetWidth - padding
          })

          div.addEventListener ('mouseover', e => {
            e.target.style.borderRight = '2px solid #e0e0e0'
          })

          div.addEventListener ('mouseout', e => {
            e.target.style.borderRight = ''
          })

          document.addEventListener ('mousemove', e => {
            if (curCol) {
              let diffX = e.pageX - pageX
          
              if (nxtCol) nxtCol.style.width = (nxtColWidth - (diffX))+'px'

              curCol.style.width = (curColWidth + diffX)+'px'
            }
          })

          document.addEventListener ('mouseup', () => { 
            curCol = undefined
            nxtCol = undefined
            pageX = undefined
            nxtColWidth = undefined
            curColWidth = undefined
          })
        }

        function createDiv (height) {
          let div = document.createElement('div')

          div.style.top = 0
          div.style.right = 0
          div.style.width = '1px'
          div.style.position = 'absolute'
          div.style.cursor = 'col-resize'
          div.style.userSelect = 'none'
          div.style.height = height + 'px'
          div.style.background = '#e0e0e0'

          return div
        }

        function paddingDiff (col) {
          if (getStyleVal(col,'box-sizing') == 'border-box') {
            return 0
          }
          
          let padLeft = getStyleVal(col,'padding-left')
          let padRight = getStyleVal(col,'padding-right')

          return (parseInt(padLeft) + parseInt(padRight))
        }

        function getStyleVal (elm,css) {
          return (window.getComputedStyle(elm, null).getPropertyValue(css))
        }
      }
    }
  }
</script>